import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { ProfilePage } from "@/modules/profile";
import { requireAuth } from "@/utils";

export const Route = createFileRoute("/settings/profile")({
  beforeLoad: requireAuth,
  component: () => (
    <>
      <DocumentTitle
        title="Profile"
        description="Manage your account profile and personal information."
      />
      <ProfilePage />
    </>
  )
});
